var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Getter, Inject, Mutation, State } from 'vue-class-state';
import { toCamelCase, toDecamelCase } from '../../common/camelize';
import { createLock, checkLogin } from '../../common/decorators';
import { post } from '../../common/http';
import { ls } from '../../common/utils';
import WatchRecord from '../interfaces/history/WatchRecord';
// 历史记录请求的项目对应的union数据
const unionData = [
    {
        table_id: 2003,
        fields: {
            episode_updated: '',
        },
    },
    {
        table_id: 2001,
        fields: {
            duration: '',
        },
    },
    {
        table_id: 1006,
        fields: {
            video_duration: '',
        },
    },
];
const filterKey = 'history_fiter_watched';
export class HistoryState {
    constructor() {
        this.isFiterWatched = true;
        this.isHasFetched = false;
        this.mods = {
            today: {
                title: '今天',
                type: 'today',
                ids: [],
            },
            yesterday: {
                title: '昨天',
                type: 'yesterday',
                ids: [],
            },
            earlier: {
                title: '更早',
                type: 'earlier',
                ids: [],
            },
        };
        this.type = txv.login.isLogin() ? 1 : 2;
        this.recordMap = {};
        /**
           * 翻页参数
           *
           **/
        this.pageContext = {};
        this.dataVersion = 0;
        this.hasNext = true;
        this.hasFetch = false;
        const isFiterStr = ls.get(filterKey, true);
        if (typeof isFiterStr === 'string') {
            this.isFiterWatched = isFiterStr === '1';
        }
    }
    get modList() {
        const arr = [];
        Object.keys(this.mods).forEach((key) => {
            arr.push(this.mods[key]);
        });
        return arr;
    }
    get hasData() {
        return this.modList.some(item => Boolean(item.ids.length));
    }
    getItem(recordId) {
        return this.recordMap[recordId] || null;
    }
    loadData(isPreFetchNextPage = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hasNext) {
                return;
            }
            try {
                if (txv.login.isLogin()) {
                    const accessDomain = location && location.host !== 'dev.v.qq.com' ? 'pbaccess.video.qq.com' : 'tpbaccess.video.qq.com';
                    const res = yield post(`//${accessDomain}/trpc.video_history.interface_server.InterfaceService/GetList?video_appid=1200022`, {
                        union_req: unionData,
                        page_context: this.pageContext,
                        data_version: 0,
                    }, true, false, {
                        'Trpc-Trans-Info': '{"history_head": "appid=web_attent&appkey=7ed56d5d-3088-48b4-b2d2-15075bf289ef"}',
                    });
                    if (res.ret === 0 && res.data && !res.data.retcode && res.data.msgs) {
                        this.insertData(toCamelCase(res.data));
                        setTimeout(() => {
                            if (isPreFetchNextPage) {
                                this.loadData();
                            }
                        }, 0);
                    }
                    else {
                        // @ts-ignore
                        window.aegis.reportEvent({
                            name: 'GetHistory Error',
                            ext1: JSON.stringify(res),
                            ext2: 'body error',
                        });
                    }
                }
                else {
                    const ret = yield this.loadLocalData();
                    this.insertData(ret, 2);
                }
            }
            catch (error) {
                console.error(error);
                // @ts-ignore
                window.aegis.reportEvent({
                    name: 'GetHistory Error',
                    ext1: JSON.stringify(error),
                });
            }
            finally {
                Mutation.commit(this, () => this.isHasFetched = true);
            }
        });
    }
    /**
       * 获取本地播放历史记录
       */
    loadLocalData() {
        return new Promise((resolve) => {
            txv.localHistory.getList(0, (res) => {
                if (Array.isArray(res)) {
                    const data = {
                        hasNext: false,
                        list: res.slice(0, 100),
                    };
                    resolve(data);
                }
                else {
                    resolve([]);
                }
            });
        });
    }
    delOneHistory(recordId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.type === 1) {
                this.delRemoteHistory(recordId);
            }
            else {
                this.delLSHistory(recordId);
            }
        });
    }
    delRemoteHistory(recordId) {
        return __awaiter(this, void 0, void 0, function* () {
            const history = this.getHistoryByRecordId(recordId);
            if (history) {
                const res = yield this.delHistorys({ recordList: [recordId], isDeleteAll: false });
                if (res.ret === 0 && res.data.data_version && res.data.results && res.data.results[0] && res.data.results[0].err_code === 0) {
                    this.delLocalHistory(recordId);
                    // 删除成功需更新版本号
                    this.dataVersion = res.data.data_version;
                }
            }
            else {
                throw new Error(`delOneHistory：没找到历史记录${recordId}`);
            }
        });
    }
    delAllHistory() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.type === 1) {
                const res = yield this.delHistorys({ isDeleteAll: true });
                if (res.ret === 0 && res.data.data_version) {
                    this.delAllLocalHistory();
                    // 删除成功需更新版本号
                    this.dataVersion = res.data.data_version;
                }
            }
            else {
                txv.localHistory.removeAll();
                this.delAllLocalHistory();
            }
        });
    }
    changeFiter(isFiter) {
        this.isFiterWatched = isFiter;
        ls.set(filterKey, this.isFiterWatched ? '1' : '0', true);
    }
    getHistoryByRecordId(recorid) {
        return this.recordMap[recorid] || null;
    }
    delHistorys(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const delUrl = `//pbaccess.video.qq.com/trpc.video_history.interface_server.InterfaceService/${data.isDeleteAll ? 'DelAll' : 'Del'}?video_appid=1200022`;
            const delParams = data.isDeleteAll ? {} : {
                record_ids: data.recordList,
                data_version: this.dataVersion,
            };
            const res = yield post(delUrl, delParams, true, false, {
                'Trpc-Trans-Info': '{"history_head": "appid=web_attent&appkey=7ed56d5d-3088-48b4-b2d2-15075bf289ef"}',
            });
            return res;
        });
    }
    delLSHistory(recordId) {
        if (recordId) {
            txv.localHistory.removeByKey(recordId);
            this.delLocalHistory(recordId);
        }
    }
    delLocalHistory(recordId) {
        this.modList.forEach((mod) => {
            mod.ids.remove(recordId);
        });
        delete this.recordMap[recordId];
    }
    delAllLocalHistory() {
        this.modList.forEach((mod) => {
            mod.ids = [];
        });
        this.recordMap = {};
        this.hasNext = false;
    }
    insertData(ret, type = 1) {
        this.pageContext = toDecamelCase(ret.pageContext);
        this.dataVersion = ret.dataVersion;
        this.hasNext = ret.hasNext;
        this.hasFetch = true;
        ret.msgs.map(item => new WatchRecord(item, type)).forEach((record) => {
            this.recordMap[record.record.recordId] = record;
            this.mods[record.historyType].ids.push(record.record.recordId);
        });
    }
}
__decorate([
    State
], HistoryState.prototype, "isFiterWatched", void 0);
__decorate([
    State
], HistoryState.prototype, "isHasFetched", void 0);
__decorate([
    State
], HistoryState.prototype, "mods", void 0);
__decorate([
    State
], HistoryState.prototype, "hasNext", void 0);
__decorate([
    State
], HistoryState.prototype, "hasFetch", void 0);
__decorate([
    Getter
], HistoryState.prototype, "modList", null);
__decorate([
    Getter
], HistoryState.prototype, "hasData", null);
__decorate([
    createLock(),
    checkLogin
], HistoryState.prototype, "loadData", null);
__decorate([
    Mutation
], HistoryState.prototype, "changeFiter", null);
__decorate([
    checkLogin
], HistoryState.prototype, "delHistorys", null);
__decorate([
    Mutation
], HistoryState.prototype, "delLocalHistory", null);
__decorate([
    Mutation
], HistoryState.prototype, "delAllLocalHistory", null);
__decorate([
    Mutation
], HistoryState.prototype, "insertData", null);
export const IHistoryState = Inject('history');
